import { CustomIcon } from "components/icon/customIcon.component";
import { ColorV2 } from "config/colors";
import {
  KeyLabel,
  KeyValueRow,
  OvertimeChip,
  Value,
  ValueWithChip,
} from "./timeReportDetailsPanel.styled";

interface TotalTimeRowProps {
  label: string;
  totalValue: string;
  overtimeLabel: string | null;
}

export const TotalTimeRow = (props: TotalTimeRowProps): JSX.Element => {
  return (
    <KeyValueRow>
      <KeyLabel>{props.label}</KeyLabel>
      <ValueWithChip>
        <Value>{props.totalValue}</Value>
        {props.overtimeLabel !== null && (
          <OvertimeChip>
            <CustomIcon
              name="v2/warning-triangle"
              size="16px"
              color={ColorV2.NegativeRed}
            />
            {props.overtimeLabel}
          </OvertimeChip>
        )}
      </ValueWithChip>
    </KeyValueRow>
  );
};
